export default __webpack_public_path__ + "static/media/paraEmpresas_01.000d7ff3.svg";